
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/v3",
      function () {
        return require("private-next-pages/my/v3/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/v3"])
      });
    }
  